/**
 * Phase 2: Company-Mapping models.
 * BE returns these after createConnectionSuccess. FE renders them in the Mapping-Modal.
 */

export interface IVendorCompany {
    externalCompanyId: string;
    externalCompanyName: string;
}

export interface IAumicoCompanySummary {
    id: string;
    name: string;
}

/**
 * One row per BC company in the manage modal's detail table.
 *
 * The wizard layer fills `suggestedAumicoCompany` from the live `tenantDetail`
 * cache (so the single edit modal can pre select the currently mapped Aumico
 * Company). When the BC company is unmapped, this stays null.
 */
export interface ICompanyMappingSuggestion {
    vendorCompany: IVendorCompany;
    suggestedAumicoCompany: IAumicoCompanySummary | null;
}
